import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { DynamicForm } from '../../DynamicForm';
import * as v from '../../../helpers/validation';
import classnames from 'classnames';

// SERVICES
import { putUnderwriterUser, getUnderwriterUserById, getClientList } from '../../../services';

const styles = {
  gridHeader: {
    marginBottom: 0,
    paddingBottom: 0,
  },
};

export const UnderwriterUsersDetail = withStyles(styles)(props => {
  const { match, setPageTitle, classes } = props;
  const { userId } = match.params;
  const [formError, setFormError] = useState(null);
  const [underwriterUserFormData, setUnderwriterUserFormData] = useState(null);
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    getClientListAsync();
  }, []);

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => {
      return {
        value: c.id,
        label: `${c.name} ${c.code && `(${c.code})`}`,
      };
    });
    setClientList(clients);
  };

  useEffect(() => {
    underwriterUserFormData && underwriterUserFormData.fname && underwriterUserFormData.lname
      ? setPageTitle(`Edit UNDERWRITER: ${underwriterUserFormData.fname} ${underwriterUserFormData.lname}`)
      : setPageTitle(`Edit UNDERWRITER`);
  }, [underwriterUserFormData]);

  useEffect(() => {
    const getUnderwriterUserByIdAsync = async () => {
      try {
        const underwriterUserObj = await getUnderwriterUserById(userId);
        setUnderwriterUserFormData(underwriterUserObj);
      } catch (error) {
        console.log(error);
        setFormError(error);
      }
    };

    getUnderwriterUserByIdAsync();
  }, []);

  const underwriterUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'select',
              field: 'clientId',
              label: 'Client',
              validate: [v.required()],
              options: clientList,
            },
            {
              inputType: 'text',
              field: 'underwriterCode',
              label: 'Underwriter Code',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'email',
              label: 'Email',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              disabled: true,
              validate: [],
            },
            {
              inputType: 'text',
              field: 'fname',
              label: 'First Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'mname',
              label: 'Middle Name',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'lname',
              label: 'Last Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'title',
              label: 'Title',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'company',
              label: 'Company',
              validate: [v.required()],
            },
            {
              inputType: 'boolean',
              field: 'recordMode',
              label: 'Record Mode',
              validate: [],
            },
            {
              inputType: 'boolean',
              field: 'emailOutput',
              label: 'Email Output',
              validate: [],
            },
            {
              inputType: 'boolean',
              field: 'receivesImportVerification',
              label: 'Receives Import Verification Email',
              validate: [],
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className={classnames('grid-container')}>
      <DynamicForm
        inputs={underwriterUserInputs}
        data={underwriterUserFormData}
        mode={'EDIT'}
        onSave={putUnderwriterUser}
        redirectOnSuccess={'/users/underwriter'}
      />
      <div>{formError}</div>
    </div>
  );
});
